import cx from 'clsx';
import * as React from 'react';

import GhostTile from '@/components/modular-grid/GhostTile';
import { selectProperStyles } from '@/components/modular-grid/utils';

import styles from './Grid.module.scss';

const GridGhost: React.FC<{ extended?: boolean }> = ({ extended = false }) => {
  return (
    <div
      className={cx(styles.insideHeader, styles.container)}
      data-testid="grid-ghost-grid"
    >
      <div className={cx(styles.rowGrid)}>
        {Array.from(Array(6).keys()).map((index: number) => (
          <div
            key={index}
            className={cx(
              selectProperStyles({
                small: styles.slotGridSmallForced,
                medium: styles.slotGridMediumForced,
                default: [styles.slotGridSmall, styles.slotGridMedium],
              }),
              styles.slot
            )}
          >
            <GhostTile extended={extended} />
          </div>
        ))}
      </div>
    </div>
  );
};
export default GridGhost;
